/** Tabs on the history page. */

export const historyTabs = ["recent", "changelog"] as const;
